import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  betStore,
  userInfoStore,
  roundInfoStore,
  useTranslation,
  TranslationKeys,
  LiveBetsContainer,
} from '@pascal/pascal-core';

import { roundsInfoStore } from '../../../store';
import { globalTranslationKeys } from '../../../enums';
import { OtherBets } from '../liveBetsItems/otherBets';
import { LiveBetsItems } from '../liveBetsItems/myBets';

export const removePastRoundBets = () => {
  const { roundId } = roundInfoStore;
  betStore.setLiveBets(betStore.liveBets.filter((bet) => bet.roundId >= roundId));
};

export const updateRoundResultsInLiveBets = () => {
  const { lastWinBets } = roundsInfoStore;
  const { roundId } = roundInfoStore;
  betStore.setLiveBets(betStore.liveBets.filter((bet) => bet.roundId > roundId));

  lastWinBets.forEach((userWinBets) => {
    const additionalData = {
      roundId: userWinBets.roundId,
      userId: userWinBets.userId,
      currencyCode: userWinBets.currencyCode,
      freeBetId: userWinBets.freeBetId,
    };
    userWinBets.additionalParams.markets.forEach((bet) => betStore.updateLiveBets({ ...bet, ...additionalData }));
  });
};

const collectBetsByRound = (bets) => {
  const betsByRounds = {};

  bets &&
    bets.forEach((bet) => {
      if (betsByRounds[bet.roundId]) {
        betsByRounds[bet.roundId].push(bet);
      } else {
        betsByRounds[bet.roundId] = [bet];
      }
    });

  return betsByRounds;
};

const getSortBetsByAmount = (bets) =>
  bets.sort((bet1, bet2) => (bet1.amount < bet2.amount ? 1 : bet1.amount > bet2.amount ? -1 : 0));

const getSortedRoundsBetsByAmount = (roundsBets) => {
  const sortedBets = [];
  for (let round in roundsBets) {
    sortedBets.push(...getSortBetsByAmount(roundsBets[round]));
  }
  return sortedBets;
};

const getSortedBetsByRoundsAndByAmounts = (bets) => getSortedRoundsBetsByAmount(collectBetsByRound(bets));

const sortLiveBets = (bets) => {
  const { userId } = userInfoStore;
  // const { isDemo } = applicationStore;
  const myUnsortedBets = bets.filter((bet) => {
    // if (isDemo) {
    //   return bet.isDemoBet;
    // }
    return bet.userId === +userId;
  });
  const otherUnsortedBets = bets.filter((bet) => bet.userId && bet.userId !== +userId);

  return [getSortedBetsByRoundsAndByAmounts(myUnsortedBets), getSortedBetsByRoundsAndByAmounts(otherUnsortedBets)];
};

export const LiveBetsWrapper = observer(() => {
  const { currencySymbolOrCode } = userInfoStore;
  const t = useTranslation();

  return (
    <LiveBetsContainer
      renderMyLiveBetItem={(data, index, list) => <LiveBetsItems data={data} index={index} list={list} />}
      renderOtherLiveBetItem={(data, index, list) => <OtherBets data={data} index={index} list={list} />}
      headerNames={[
        { name: `${t(TranslationKeys.PlayerId)}` },
        { name: `${t(globalTranslationKeys.Bet)} (${currencySymbolOrCode})` },
        { name: `${t(globalTranslationKeys.BetType)}` },
        { name: `${t(globalTranslationKeys.Win)} (${currencySymbolOrCode})` },
      ]}
      customSortFunctional={sortLiveBets}
    />
  );
});
